import { render, staticRenderFns } from "./DislociraneEnote.vue?vue&type=template&id=984fd38e&"
import script from "./DislociraneEnote.vue?vue&type=script&lang=js&"
export * from "./DislociraneEnote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports